import { fieldMap } from "./helpers/map-cargo-packing";

export const liteWmsFilter = [
  {
    section: "Cargo Details + Tracking",
    filters: [
      { id: "shipping_case__label", label: "Shipping Case" },
      { id: "customer", label: "Customer" },
      { id: "importer", label: "Importer" },
      { id: "supplier", label: "Supplier Of The Goods" },
      { id: "producer", label: "Mill Installation" },
      { id: "producer_mill", label: "Mill Operator" },
      { id: "bill_of_lading", label: "Bill of Lading" },
      { id: "vessel", label: "Vessel" },
      { id: "commodities", label: "Commodities" },
      { id: "production_method", label: "Production Method" },
      { id: "id_number", label: "ID Number" },
      { id: "thickness", label: "Thickness" },
      { id: "width", label: "Width" },
      { id: "length", label: "Length" },
      { id: "pieces", label: "Pieces" },
      { id: "net_weight", label: "Net Weight" },
      { id: "gross_weight", label: "Gross Weight" },
      { id: "grade", label: "Grade" },
      { id: "heat", label: "Heat" },
      { id: "comment_1", label: "Note 1 (DDT)" },
      { id: "comment_2", label: "Note 2 (DDT)" },
      { id: "ddt_customer_reference", label: "DDT Customer Reference" },
      { id: "customer_reference", label: "Customer Reference" },
      { id: "container", label: "Container" },
    ],
  },
  {
    section: "Customs",
    filters: [
      { id: "hs_code", label: "HS code" },
      { id: "caad", label: "Cadd additional code" },
    ],
  },
  {
    section: "FCR",
    filters: [
      { id: "fcr", label: "FCR" },
      { id: "fcr_status", label: "FCR Status" },
    ],
  },
  {
    section: "Unloading/Warehousing",
    filters: [
      { id: "terminal", label: "Terminal of Discharge" },
      { id: "deposit_reference", label: "Deposit Reference" },
      { id: "warehousing", label: "Warehousing" },
      { id: "pile", label: "Pile" },
      { id: "row", label: "Row" },
      { id: "tiers", label: "Tiers" },
      { id: "depot", label: "Depot" },
      { id: "note", label: "Note" },
      { id: "claims", label: "Claims" },
      { id: "marks", label: "Marks" },
      { id: "sender", label: "Sender/Depositor" },
      { id: "consignee", label: "Consignee" },
      { id: "destination", label: "Destination" },
      { id: "delivery_info", label: "Loading Order" },
      { id: "loading_ddt_created", label: "DDT Date" },
      { id: "transport_reason", label: "Reason of Transport" },
    ],
  },
  {
    section: "Delivery",
    filters: [
      { id: "transport_contactor", label: "Transport Contractor" },
      { id: "delivery_status", label: "Status" },
      { id: "loading_ddt", label: "DDT" },
      { id: "truck_supplier", label: "Carrier" },
      { id: "truck_kind", label: "Means of Transport" },
    ],
  },
];

export const TRUCK_KIND = [
  { id: "NORMAL", label: "Camion normale" },
  { id: "CONTAINER", label: "Camion contenitore" },
  { id: "EXCEPTIONAL", label: "Camion eccezionale" },
  { id: "TRAIN", label: "Treno" },
];

export const RELEASE_STATUS_IS_NULL = [
  { id: false, label: "Released" },
  { id: true, label: "Not Released" },
];

export const DYNAMIC_AUTOCOMPLETE_FIELDS = [
  "TERMINAL_OF_DISCHARGE",
  "WAREHOUSING",
  "SENDER_DEPOSITOR",
];

export const TRANSPORT_REASON = [
  { id: "IMPORT", label: "Importazione" },
  { id: "STORAGE", label: "Conto deposito" },
  { id: "SALE", label: "Conto vendita" },
  { id: "PROCESSING", label: "Conto lavoro" },
  { id: "TRANSFER", label: "Trasferimento" },
  { id: "INSPECTION", label: "Conto visione" },
];

export const PACK_STATUSES = [
  {
    id: "NOT_SHIPPABLE",
    label: "Not Shippable",
    section: "Delivery",
  },
  {
    id: "IN_STOCK",
    label: "In Stock",
    section: "Delivery",
  },
  {
    id: "BOOKED",
    label: "Booked",
    section: "Delivery",
  },
  {
    id: "DELIVERED",
    label: "Delivered",
    section: "Delivery",
  },
  {
    id: "WHS_SCHEDULED",
    label: "WHS Scheduled",
    section: "Warehouse Shifting",
  },
  { id: "WHS_BOOKED", label: "WHS Booked", section: "Warehouse Shifting" },
];

export const SHIFTING_STATUSES = [];

export const FIELDS_DEPENDENT_ON_TRANSPORT_DOCUMENT: (keyof typeof fieldMap)[] =
  ["CARRIER", "MEANS_OF_TRANSPORT"];

export const SUPPLIER_TERMINAL_COLUMNS = [
  "shipping_case__label", // SC
  "customer", // Customer
  "importer", // Importer
  "bill_of_lading", // BL
  "ocean_vessel", // Vessel
  "commodities", // Commodities
  "id_number", // ID Number
  "thickness", // Thickness
  "width", // Width
  "length", // Length
  "pieces", // Pieces
  "net_weight", // Net Weight
  "gross_weight", // Gross Weight
  "grade", // Grade
  "heat", // Heat
  "discharge_terminal", // Terminal of Discharge
  "warehouse", // Warehousing
  "pile", // Pile
  "rows", // Row
  "tiers", // Tiers
  "depot", // Depot
  "claims", // Claims
  "marks", // Marks
  "sender_depositor", // Sender/Depositor
  "consignee", // Consignee
  "destination", // Destination
  "date_unloading", // DDT date
  "status_delivery", // Status
  "transport_document", // DDT
  "intro_customs_bill_type", // Customs Document Type Intro
  "intro_mrn_code", // Customs Document MRN Intro
  "customs_bill_type", // Customs document type
  "mrn_code", // Customs document MRN
  "customs_release_code", // A14
  "customs_release_date", // A14 date
] as const;

export const SUPPLIER_TERMINAL_FILTERS = [
  "shipping_case__label",
  "customer",
  "importer",
  "bill_of_lading",
  "vessel",
  "commodities",
  "id_number",
  "thickness",
  "width",
  "length",
  "pieces",
  "net_weight",
  "gross_weight",
  "grade",
  "heat",
  "terminal", // Terminal of Discharge
  "warehousing", // Warehousing
  "pile",
  "row",
  "tiers",
  "depot",
  "claims",
  "marks",
  "sender", // Sender/Depositor
  "consignee",
  "destination",
  "loading_ddt_created", // DDT date
  "delivery_status", // Status
  "loading_ddt", // DDT
];
